import { categories } from '@/mocks/homeData';
import SectionHead from './SectionHead';

const chipStyles = [
  'bg-primary-100 text-primary-800 hover:bg-primary-500 hover:text-background-50',
  'bg-accent-100 text-accent-900 hover:bg-accent-500 hover:text-foreground-950',
  'bg-secondary-100 text-secondary-900 hover:bg-secondary-500 hover:text-background-50',
];

export default function CategoryIndex() {
  return (
    <section id="lei-xing" className="border-y border-background-200 bg-background-100/70">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <SectionHead
          index="档案 02"
          kicker="五大证据品类"
          title="材料进来，先按品类归位"
          desc="每一条爆料在进库前先贴上品类标签。点进任意一类，就能只挑这一种材料看，不掺水、不打乱。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {categories.map((c, i) => (
            <a
              key={c.name}
              href="#lei-xing"
              className="group flex cursor-pointer flex-col justify-between rounded-lg bg-background-50 p-5 transition-all duration-200 hover:-translate-y-0.5"
            >
              <div>
                <div
                  className={`flex h-11 w-11 items-center justify-center rounded-md text-xl transition-colors duration-200 ${chipStyles[i % chipStyles.length]}`}
                >
                  <i className={c.icon} aria-hidden="true"></i>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{c.name}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              </div>
              <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                <span className="font-heading text-sm font-black text-primary-600">{c.count}</span>
                <span className="flex items-center gap-1 text-xs text-foreground-500 transition-colors duration-200 group-hover:text-primary-600">
                  进区查看
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}